import { CommonModule } from '@angular/common';
import { NoDataComponent } from './no-data.component';
import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
    declarations: [NoDataComponent],
    imports: [CommonModule, NzButtonModule],
    exports: [NoDataComponent],
})
export class NoDataModule {}
